import { render } from "./NetflixIcon.vue?vue&type=template&id=7bec59d8&scoped=true"
import script from "./NetflixIcon.vue?vue&type=script&lang=js"
export * from "./NetflixIcon.vue?vue&type=script&lang=js"

import "./NetflixIcon.vue?vue&type=style&index=0&id=7bec59d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bec59d8"]])

export default __exports__